import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { StatusType } from '@vi-iot/client';

import { StatusPageActions } from './status-page.actions';
import { StatusPageState } from './status-page.state';

export const initStatusPageState: StatusPageState = {
  status: StatusType.Operational,
  getStatusLoaded: false,
  error: false,
  maintenances: [],
  getMaintenancesLoaded: false,
};

export const statusPageReducer: ActionReducer<StatusPageState, Action> = createReducer(
  initStatusPageState,

  on(
    StatusPageActions.getStatus,
    (state): StatusPageState => ({
      ...state,
      getStatusLoaded: false,
    })
  ),

  on(
    StatusPageActions.getStatusError,
    (state): StatusPageState => ({
      ...state,
      getStatusLoaded: true,
      error: true,
    })
  ),

  on(
    StatusPageActions.getStatusSuccess,
    (state, { status }): StatusPageState => ({
      ...state,
      getStatusLoaded: true,
      status,
    })
  ),

  on(
    StatusPageActions.getMaintenances,
    (state): StatusPageState => ({
      ...state,
      getMaintenancesLoaded: false,
    })
  ),

  on(
    StatusPageActions.getMaintenancesSuccess,
    (state, { maintenances }): StatusPageState => ({
      ...state,
      maintenances,
      getMaintenancesLoaded: true,
    })
  ),

  on(
    StatusPageActions.getMaintenancesError,
    (state): StatusPageState => ({
      ...state,
      getMaintenancesLoaded: true,
    })
  )
);
